/* Spanish catalog mirroring locale-invoice-control-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'pageControl.noProgress': 'Me detuve porque se propuso el mismo paso otra vez sin avanzar. La revisión solicitada no está completa.',
  'pageControl.unverified': 'No tengo una observación confirmada del resultado y no puedo afirmar que la tarea esté completa.',
  'control.expand': 'Ampliar chat',
  'control.collapse': 'Contraer chat',
  'control.proposalIncomplete': 'La propuesta de factura está incompleta. No se han rellenado las líneas ni los detalles. Proporciona la información que falta o completa el formulario.',
  'control.reloadRequired': 'El control de facturas se ha actualizado. Recarga esta página antes de continuar. No se modificó ningún campo.',
  'control.fieldsApplied': 'El cliente y las líneas de la factura se han rellenado en el formulario. El borrador no se ha guardado.',
  'control.customerApplied': 'El cliente se ha seleccionado en el formulario de factura.',
  'control.onepageApplied': 'La vista ha cambiado a todo en una sola página.',
  'control.stepsApplied': 'La vista ha cambiado a paso a paso.',
  'control.editorOpened': 'La página de nueva venta está abierta.',
  'control.listOpened': 'La lista de facturas está abierta.',
  'control.saveReady': 'El borrador se puede guardar cuando me pidas que lo guarde.',
  'control.noChange': 'No se modificó ningún campo. Describe qué introducir en la factura.',
  'control.title': 'SuperPlumma hace el trabajo',
  'control.scope': '¿Qué te gustaría hacer?',
  'control.you': 'Tú',
  'control.input': '¿Qué te gustaría hacer?',
  'control.run': 'Ejecutar',
  'control.speak': 'Voz',
  'control.stopMic': 'Cancelar voz',
  'control.stop': 'Detener',
  'control.minimize': 'Minimizar asistente',
  'control.newChat': 'Iniciar un chat nuevo',
  'control.working': 'Plumme está trabajando …',
  'control.saved': 'Borrador guardado. La factura no se ha enviado.',
  'control.reviewHelp': 'Revisa la vista previa de la factura. Usa “Crear factura” y las opciones de envío habituales para terminar.',
  'control.save': 'Guardar borrador',
  'control.listening': 'Escuchando …',
  'control.voiceUnsupported': 'La voz no está disponible en este navegador. Aún puedes escribir.',
  'control.voiceFailed': 'No se pudo reconocer la voz. Comprueba el acceso al micrófono o escribe tu mensaje.',
  'control.editorUnavailable': 'El editor de facturas no está disponible. Abre la factura e inténtalo de nuevo.',
  'control.editorChanged': 'La factura cambió mientras trabajaba. Vuelve a pedir el cambio para que pueda usar los campos más recientes.',
  'control.invoiceOnly': 'Este modo admite facturas. Usa el asistente habitual para otras tareas.',
  'control.agentUnavailable': 'El control de facturas necesita el nuevo servicio de asistente, que no está disponible actualmente. No se aplicó ningún cambio.',
  'control.advancedInvoice': 'Esta factura tiene detalles que, en esta primera versión, deben editarse en el formulario. No se modificó ningún campo.',
  'control.customerRequired': 'Elige un cliente existente o crea primero el cliente en el registro de clientes.',
  'control.incomplete': 'Elige un cliente y añade una línea de factura antes de guardar.',
  'control.saveBeforeLeaving': 'Guarda el borrador antes de abrir la lista de facturas para conservar tus cambios.',
  'control.failed': 'No se pudo completar la tarea. Inténtalo de nuevo.',
  'pageControl.working': 'Trabajando en la página ...',
  'pageControl.done.applied': 'Los campos se actualizaron en la página habitual.',
  'pageControl.done.saved': 'La acción se completó mediante el flujo de guardado habitual de la página.',
});
